import React from "react";
import { Parallax } from "react-parallax";

const Home = () => {
  return (
    <div className="overflow-x-hidden">
      {/* Hero Section with Parallax */}
      <Parallax bgImage="/images/imperial_cloud.jpg" strength={300} bgImageStyle={{ objectFit: "cover" }}>
        <div className="h-screen flex flex-col items-center justify-center text-center bg-black bg-opacity-50">
          <h1 className="text-5xl md:text-7xl font-extrabold uppercase text-white drop-shadow-lg">
            Imperium Cloud Storage
          </h1>
          <p className="mt-4 text-xl md:text-2xl text-blue-200">
            In the Emperor's name, your data is eternal.
          </p>
        </div>
      </Parallax>

      {/* Section 2: The Imperial Astronomican */}
      <section className="py-20 px-4 bg-gray-900 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6 text-center">The Imperial Astronomican</h2>
          <p className="text-lg leading-relaxed">
            As the beacon that guides the lost souls of the Imperium, the Imperial Astronomican
            illuminates our path through the warp. Here at Imperium Cloud, we harness its divine
            radiance to ensure your data is guarded by the Emperor’s most loyal custodians.
          </p>
        </div>
      </section>

      {/* Section 3: The Adeptus Mechanicus */}
      <Parallax bgImage="/images/adeptus_mechanicus.jpg" strength={200} bgImageStyle={{ objectFit: "cover" }}>
        <section className="py-20 px-4 bg-black bg-opacity-75 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6 text-center">The Adeptus Mechanicus</h2>
            <p className="text-lg leading-relaxed">
              The sacred engineers of the Machine God have forged our data repository in the fires of
              the Omnissiah’s wisdom. With ritual precision and the blessings of the cogitators, they
              ensure your files remain uncorrupted through the ages.
            </p>
          </div>
        </section>
      </Parallax>

      {/* Section 4: Our Vision */}
      <section className="py-20 px-4 bg-gray-800 text-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl font-bold mb-6 text-center">Our Vision</h2>
          <p className="text-lg leading-relaxed">
            Our vision is to create an imperishable archive for the Imperium’s digital relics. Like the
            eternal vigilance of the Imperial Guard, our servers stand ever watchful—preserving your legacy
            with the unwavering discipline of the Mechanicus.
          </p>
        </div>
      </section>

      {/* Section 5: Call to Action */}
      <Parallax bgImage="/images/imperial_banner.jpg" strength={300} bgImageStyle={{ objectFit: "cover" }}>
        <section className="py-20 px-4 bg-black bg-opacity-60 text-white">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl font-bold mb-6">Join the Emperor’s Digital Legions</h2>
            <p className="text-lg leading-relaxed mb-8">
              Enlist in our digital crusade and safeguard your data as if it were the very relics of the
              Imperium. With our technology forged by the Adeptus Mechanicus, your files shall be immortal.
            </p>
            <a
              href="/register"
              className="px-6 py-3 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-full transition"
            >
              Enlist Today
            </a>
          </div>
        </section>
      </Parallax>
    </div>
  );
};

export default Home;